(function($){
  let pc = null;
  $(document).ready(function(){
    pc = new ProductCompare();
  });
  addEventListener("pageshow", (event) => {
    if ( pc ) {
      pc.updateWidget();
    }
  });
  $('body').on('pop-open', (event) => {
    pc.updateWidget();
  });

})(jQuery);

class ProductCompare {

  constructor(){
    const _this = this;

    this.list = [];
    this.pageCompare = '/pages/compare';

    this.listGet();
    this.updateWidget();

  }

  updateWidget() {
    const _this = this;
    const $ps = $('.product, .product-teaser2');
    $ps.each(function (i) {
      const $p = $(this);
      const h = $p.data('product-handle');
      const $w = $p.find('.product__compare');
      if ( $w.length && !$w.find('.product__compare__check').length ) {
        const id = 'compare-'+i;
        $w.html('' +
          '<div class="product__compare__check form-type-checkbox">' +
          '<input id="'+id+'" type="checkbox" value="1">' +
          '<label for="'+id+'">Compare</label>' +
          '</div>' +
          '<a class="as-b as-b--bordered product__compare__link hidden" href="#">' +
          'Compare Selected' +
          '</a>' +
          '');

        $w.find('input').on('change', function() {
          const $i = $(this);
          const h = $i.closest('.product, .product-teaser2').data('product-handle');
          if ($i.is(':checked')) {
            _this.listAdd(h);
          } else {
            _this.listRemove(h);
          }
          _this.listSave();
          _this.updateWidget();
        });
      }
      const $i = $w.find('input');
      if ( _this.listExists(h)) {
        $i.prop('checked', true);
      } else {
        $i.prop('checked', false);
      }
      const $l = $w.find('.product__compare__link');
      $l.attr('href', _this.URLGet());
      if ( _this.listExists(h)) {
        $l.removeClass('hidden');
      } else {
        $l.addClass('hidden');
      }
    });

    const $w = $('.product-compare');
    if ( $w.length ) {
      $w.find('.product-teaser2').each(function () {
        const $t = $(this);
        const h = $t.data('product-handle');
        const $lw = $t.find('.product-teaser2__compare');
        const $l = $lw.find('a');
        if ( !$l.length ) {
          $lw.html('<a href="#" class="link-remove">\n' +
            '        Remove from Comparison\n' +
            '      </a>');
          const $l = $lw.find('a');
          $lw.removeClass('hidden');
          $l.on('click', function(e) {
            e.preventDefault();
            _this.listRemove(h);
            _this.listSave();
            $t.remove();
            const url = _this.URLGet();
            if ( typeof history.replaceState != 'undefined' ) {
              history.replaceState ( {}, document.title, url );
            }
            _this.updateWidget();
          });
        }
      });
    }

  }

  URLGet( list ) {
    if ( typeof list === 'undefined' ) {
      list = this.list;
    }
    let url = this.pageCompare+'/'+list.join(',');
    return url;
  }

  listExists(item) {
    return this.list.includes(item);
  }

  listAdd(item) {
    if ( !this.listExists(item)) {
      this.list.push(item);
    }
    if ( this.list.length > 4 ) {
      this.list.splice(0,1);
    }
  }

  listRemove(item) {
    const i = this.list.findIndex((v) => v === item);
    if ( i >= 0 ) {
      this.list.splice(i, 1);
    }
  }

  listSave() {
    localStorage.setItem('sw-product-compare', JSON.stringify(this.list));
  }

  listGet() {
    const _this = this;
    const $w = $('.product-compare');
    if ( $w.length ) {
      this.list = [];

      $w.find('.product-teaser2').each(function() {
        const h = $(this).data('product-handle');
        if ( h ) {
          _this.list.push(h);
        }
      });

      this.listSave();

    } else {

      try {
        this.list = JSON.parse(localStorage.getItem('sw-product-compare'));
      } catch ( e ) {
        this.list = [];
      }
      if ( !this.list || typeof this.list !== 'object' ) {
        this.list = [];
      }

    }

  }

}
